import { useGetGradesQuery } from "../../actions/actionsApiSlice";
import useTitle from '../../../hooks/useTitle'
import PulseLoader from "react-spinners/PulseLoader";
import { useParams } from "react-router-dom";
import StudentGrade from './StudentGrade'
const StudentGradesList = ({task}) => {

useTitle('geshtop-Exercise: Actions List')
//const { username, isTeacher, isAdmin } = useAuth()
const {groupId} = useParams()
const {
    data: grades,
    isLoading,
    isSuccess,
    isError,
    error
} = useGetGradesQuery('UserGradeList', {
    // pollingInterval: 15000,
    // refetchOnFocus: true,
   // refetchOnMountOrArgChange: true,
})



let content

if (isLoading) content = <PulseLoader color={"#FFF"} />

if (isError) {
    content = <p className="errmsg">{error?.data?.message}</p>
}

if (isSuccess) {
    let filterGrades = []
    if((groupId!=='0')||  task!==''){
        filterGrades=grades.filter(grade =>{
         return    (groupId==='0' || grade.group === groupId ) &&
                    (task==='' ||(grade.task ===task ))

        })
    }else
        {
            filterGrades = [...grades]
        }


    const tableContent = (!filterGrades.length)? <div>אין הגשות להצגה</div> :  filterGrades.map(action => <StudentGrade key={action._id} action={action} />)


    content = (
        <> 
       
        <table className="table table--grades">
            <thead className="table__thead">
                <tr>
                    <th scope="col" className="table__th grade__task">משימה</th>
                    <th scope="col" className="table__th grade__text">הערות בדיקה</th>
                    <th scope="col" className="table__th grade__status">מצב ההגשה</th>
                    <th scope="col" className="table__th grade__grade">ציון</th>
                    <th scope="col" className="table__th grade__edit">#</th>
                </tr>
            </thead>
            <tbody>
                {tableContent}
            </tbody>
        </table>
        </>
    )
}

return content




}

export default StudentGradesList